import React, { useEffect, useMemo, useState } from "react"
import { Container } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { getTableSortingHeaderIcon } from "helpers/common"
import { usePermission } from "hooks/usePermission"
import Breadcrumb from "components/Common/Breadcrumb"
import { useLazyGetSigningRequestsQuery } from "store/api/investorapi/icds.api"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
  redirection_url: window.location.href,
}

const SigningRequests = () => {
  const [getResults, { isFetching }] = useLazyGetSigningRequestsQuery()
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [filters, setFilters] = useState(defaultFilters)
  const { hasPermission } = usePermission()

  //meta title
  document.title = "Signing Requests - Prachay"

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        id: "created_at",
        accessorFn: (row) =>
          row?.created_at ? new Date(row.created_at).getTime() : null,
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.formatted_created_at,
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Request ID"),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="">
            {row?.original.template_type === "TERM_SHEET"
              ? row?.original.icdsRequests?.icds?.unique_code
              : row?.original?.agreement_ref}
          </div>
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Document Type"),
        accessorKey: "template_type",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-status">
            {row?.original.template_type === "TERM_SHEET" ? (
              <div className="badge approved">
                <span></span> ICD Schedule Terms
              </div>
            ) : (
              <div className="badge counteroffer">
                <span></span> ICD Master Agreement
              </div>
            )}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => (
          <div className="d-flex flex-column align-items-center gap-1 buttons">
            <a href={row.original.doc}>Sign Now</a>
          </div>
        ),
      },
    ]

    return data
  }, [hasPermission])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Signing Requests"} />

          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isCustomPageSize={true}
            // isGlobalFilter={true}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SigningRequests
